module.exports = __webpack_public_path__ + "img/go-back-sm.f8a82309.svg";